module.exports = __webpack_public_path__ + "img/ic_backspace.28d0a95c.svg";